import React from 'react';

export const Footer: React.FC = () => {
    return (
        <footer className="bg-gray-800 text-gray-300 p-4 text-center">
            <p>&copy; {new Date().getFullYear()} Botswana Telecommunications Corporation. All rights reserved.</p>
            <p>Contact: itdevelopment@btc.bw</p>
        </footer>
    );
};
